import React, { useEffect, useState } from 'react'
import { Link, Outlet, useLocation, useParams } from 'react-router-dom'
import { UserDetailSlice } from '../../../redux/features/UserManagementSlice';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { getparamsString } from '../../../utils/helper';

const UserManagementDetailsOutlet = () => {

  const {id} = useParams();
  const dispatch = useDispatch();
  const location = useLocation()?.pathname?.split('/') || [];
  console.log("location:",location)
  const type = getparamsString("type");
  console.log("type:",type);

   useEffect(() => {
  const fetchUser = async () => {
    const params = new URLSearchParams({ type }).toString();

    try {
      const response = await dispatch(
        UserDetailSlice({ id, params })
      ).unwrap();

      console.log(response);
    } catch (error) {
      toast.error(error?.message || "Failed to fetch user details");
    }
  };

  fetchUser();
}, [id, type, dispatch]);

  
  return (
    <>
    <div className="TitleBox">
  <h4 className="Title">User Management</h4>
</div>
    <div className="CommonTabs">
  <ul className="nav nav-tabs">
    <li className="nav-item">
      <Link className={`nav-link ${location.includes('PersonalDetails') ? 'active' : ''}`}  data-toggle="tab" to={`PersonalDetails/${id}?type=basic`}>
        Personal Detail
      </Link>
    </li>
    <li className="nav-item">
      <Link className={`nav-link ${location.includes('NewsPreferences') ? 'active' : ''}`} data-toggle="tab" to={`NewsPreferences/${id}?type=preference`}>
        News Preferences
      </Link>
    </li>
    {/* <li className="nav-item">
      <Link className={`nav-link ${location.includes('UserEnagement') ? 'active' : ''}`} data-toggle="tab" to={`UserEnagement/${id}`}>
        User Engagement
      </Link>
    </li> */}
    {/* <li className="nav-item">
      <Link className="nav-link" data-toggle="tab" to={`Bookmarks/${id}`}>
        Bookmarks
      </Link>
    </li>
    <li className="nav-item">
      <Link className="nav-link" data-toggle="tab" to={`OfflineSave/${id}`}>
        Offline Save
      </Link>
    </li> */}
    
    <li className="nav-item">  
      <Link className={`nav-link ${location.includes('QuizPreferences') ? 'active' : ''}`} data-toggle="tab" to={`QuizPreferences/${id}?type=preference`}>
      Quiz Prefrences
      </Link>
    </li> 
    
    <li className="nav-item">
      <Link className={`nav-link ${location.includes('UserQuizLeaderBoad') ? 'active' : ''}`} data-toggle="tab" to={`UserQuizLeaderBoad/${id}?type=quiz`}>
        User Quiz Statistics
      </Link> 
    </li>
  </ul>
</div>

     <Outlet/> 
    </>
  )
}

export default UserManagementDetailsOutlet
